import { defineMessages } from '@/i18n'

export const messages = defineMessages({
  ru: {
    creating: 'Создание…',
    createCourse: 'Создать курс',
    courseFallback: 'Курс',
    deleteTitle: 'Удалить курс?',
    deleteDescription: (name: string) => `«${name}» будет удалён без возможности восстановления.`,
    cancel: 'Отмена',
    delete: 'Удалить',
    filterAll: 'Все',
    filterDrafts: 'Черновики',
    filterPublished: 'В каталоге',
    filterLink: 'По ссылке',
    searchPlaceholder: 'Найти курс по названию',
    noCoursesYet: 'Ой, а у вас ещё нет ни одного курса…',
    nothingFound: 'Ой, ничего не нашлось…',
  },
  en: {
    creating: 'Creating…',
    createCourse: 'Create course',
    courseFallback: 'Course',
    deleteTitle: 'Delete course?',
    deleteDescription: (name: string) => `“${name}” will be deleted permanently.`,
    cancel: 'Cancel',
    delete: 'Delete',
    filterAll: 'All',
    filterDrafts: 'Drafts',
    filterPublished: 'In catalog',
    filterLink: 'By link',
    searchPlaceholder: 'Find a course by title',
    noCoursesYet: "Oops, you don't have any courses yet…",
    nothingFound: 'Oops, nothing found…',
  },
})
